<template>
    <div>
        <!-- MAIN IMAGE -->
        <section>
            <v-layout column align-center justify-center class="white--text">
                <img :src="getMainPicture($route.params.roomName)" style="object-fit: cover" alt="" height="600px" width="100%">
            </v-layout>
        </section>

        <!-- INTRO -->
        <section>
            <v-layout row wrap align-center>
                <v-flex xs12 sm12 md12 lg12 text-xs-center class="pa-5">
                    <p class="room-type">
                        {{$t(`rooms.${$route.params.roomName}.type`)}}
                    </p>
                    <p class="room-name">
                        {{$t(`rooms.${$route.params.roomName}.name`)}}
                    </p>
                    <p class="mt-4 description-ita">
                        <span class="service">{{$t(`rooms.${$route.params.roomName}.services_title`)}}</span>
                        <span>{{$t(`rooms.${$route.params.roomName}.services_detail`)}}</span>
                    </p>
                    <p class="mt-4 description">
                        <span class="service">{{$t(`rooms.${$route.params.roomName}.surface_title`)}}</span>
                        <span>{{$t(`rooms.${$route.params.roomName}.surface`)}}</span>
                    </p>
                    <p class="mt-4 description">
                        <span class="service">{{$t(`rooms.${$route.params.roomName}.beds_title`)}}</span>
                        <span>{{$t(`rooms.${$route.params.roomName}.beds_detail`)}}</span>
                    </p>
                </v-flex>
            </v-layout>
        </section>

        <!-- IMAGES -->
        <section>
            <v-layout row wrap class="px-0 mx-0">
                <v-flex xs12 sm12 md4 lg4>
                    <img :src="getTris($route.params.roomName)[0]" class="my-fit">
                </v-flex>
                <v-flex xs12 sm12 md4 lg4>
                    <img :src="getTris($route.params.roomName)[1]" class="my-fit">
                </v-flex>
                <v-flex xs12 sm12 md4 lg4>
                    <img :src="getTris($route.params.roomName)[2]" class="my-fit">
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods: {
        getMainPicture(roomName){
            switch(roomName.toLowerCase()){
                case 'ammiraglio':
                    return require(`../assets/img/${roomName.toLowerCase()}/ammiraglio 5.jpeg`);
                case 'mozzo':
                    return require(`../assets/img/${roomName.toLowerCase()}/mozzo 3.jpeg`);
                case 'nostromo':
                    return require(`../assets/img/${roomName.toLowerCase()}/nostromo 3.jpeg`);
                case 'capitano':
                    return require(`../assets/img/${roomName.toLowerCase()}/capitano 4.jpeg`);
            }
        },

        getTris(roomName) {
            let pics = [];

            switch(roomName.toLowerCase()){
                case 'ammiraglio':
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/ammiraglio 3.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/ammiraglio10.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/ammiraglio 4 bagno.jpeg`));
                    break;

                case 'mozzo':
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/mozzo 2.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/mozzo6.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/mozzo1.jpeg`));
                    break;

                case 'nostromo':
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/nostromo 4 bagno.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/nostromo 1.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/nostromo 5 balcone.jpeg`));
                    break;

                case 'capitano':
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/capitano 3.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/capitano 5 bagno.jpeg`));
                    pics.push(require(`../assets/img/${roomName.toLowerCase()}/capitano 4.jpeg`));
                    break;
            }

            return pics;
        }
    }
}
</script>

<style scoped>
    .room-type{
        font-size: large;
        font-weight: 500;
        text-transform: uppercase;
    }

    .room-name{
        font-size: xx-large;
        font-weight: 400;
    }

    .service{
        font-weight: 500;
    }

    .description-ita{
        font-size: large;
        font-style: italic;
    }
    .description{
        font-size: large;
    }

    .my-fit{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 500px;
    }
</style>